
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import Utils from "@/utilities/Utils";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import { Site } from "@/model/Site";
    import { PermitZone } from "@/model/PermitZone";

    @Component({
        components: { PrimaryButton, ConfirmDialogue }
    })
    export default class PermitZoneList extends Vue {

        async mounted(): Promise<void> {
            //await this.loadVisitorCompanies();
        }

        @Prop({ required: true })
        site!: Site;

        get isNewSite(): boolean { return Utils.isEmptyId(this.site.id); }

        //
        // -- update
        //

        shouldShowEditDialogue = false;
        editingDescription = "";
        editingZone: PermitZone|null = null;

        editDescription(item: PermitZone) {
            this.editingZone = item;
            this.editingDescription = item.description;
            this.shouldShowEditDialogue = true;
        }

        updateDescription() {
            if(Utils.isEmptyOrWhitespace(this.editingDescription)) {
                toastr.warning("The description cannot be blank!");
                return;
            }
            if(this.editingZone) {
                this.editingZone.description = this.editingDescription;
            }
            this.editingDescription = "";
            this.shouldShowEditDialogue = false;
        }

        //
        // -- add
        //

        newZoneText: string = "";
        justAddedZone: PermitZone|null = null;

        addZone() {
            if(Utils.isEmptyOrWhitespace(this.newZoneText)) {
                toastr.warning("Can't add blank description");
                return;
            }
            const zone = new PermitZone({
                description: this.newZoneText,
                subZones: []
            });
            this.site.permitZones.push(zone);
            this.newZoneText = "";
            this.site.permitZones = this.site.permitZones.sort((a, b) => {
                console.log(`...SORT ${a.description} : ${b.description}`)
                return a.description.localeCompare(b.description);
            });
            this.justAddedZone = zone;
            setTimeout(() => {
                this.justAddedZone = null;
            }, 1990);
        }

        // pulse effect for just added
        pulseRedClass(zone: PermitZone) {
            return {
                "pulse-red-longer": zone === this.justAddedZone
            }
        }

        //
        // -- remove
        //

        removeDialogueTitle = "";
        removeDialogueText = "";
        removeZoneIndex = -1;

        removeZone(zone: PermitZone) {
            this.removeDialogueTitle = "Remove Zone";
            this.removeDialogueText = `Are you sure you want to remove '${zone.description}'?`
            this.removeZoneIndex = this.site.permitZones.indexOf(zone);
            const dialog: ConfirmDialogue = this.$refs.removeDialogue as ConfirmDialogue;
            dialog.show();
        }

        doRemove() {
            const dialog: ConfirmDialogue = this.$refs.removeDialogue as ConfirmDialogue;
            dialog.hide();
            if(this.removeZoneIndex < 0) return;
            const zone = this.site.permitZones[this.removeZoneIndex];
            let description = "";
            description = `Removed ${zone.description}.`;
            this.site.permitZones.splice(this.removeZoneIndex, 1);
            this.removeZoneIndex = -1;
            toastr.info(description);
        }
    }
